import React from 'react';
import { Container } from 'react-bootstrap';

function Footer() {
  return (
    <footer className="footer mt-auto py-3 bg-light">
      <Container className="text-center">
        <span className="text-muted">© AWS 2024. All rights reserved.</span>
      </Container>
    </footer>
  );
}

export default Footer; 